import React, { useEffect, useRef, useState } from 'react';
import PropTypes from 'prop-types';

import { useUrlSearch } from 'core/search';

import { ManageSearch } from 'uikit/manage';

import useDebounce from '../hooks/useDebounce';

const ManageSearchContainer = ({
  customFilterText = '',
  filters = [],
  hasCustomFilterButton = false,
  isCustomFilterButtonDisabled = false,
  isCustomFilterChatOpen = false,
  isDisabled = false,
  onCustomFilterButtonClick = () => {},
  onCustomFilterTextClick = () => {},
  searchQueryParam = 'search',
}) => {
  const urlSearch = useUrlSearch();
  const searchQueryValue = urlSearch.getValue(searchQueryParam) || '';
  const [searchValue, setSearchValue] = useState(searchQueryValue);
  const hasCustomFilter = Boolean(customFilterText);
  const filterDrawerTriggerRef = useRef(null);
  const isFilterDrawerOpen = false; // TODO
  const isSelectingFilters = isFilterDrawerOpen || isCustomFilterChatOpen;

  useEffect(() => setSearchValue(searchQueryValue), [searchQueryValue]);

  const clearFilters = () => {
    const params = urlSearch.getParams();

    filters.map(({ key }) => key).forEach((param) => params.delete(param));
    params.delete('filter_token');
    params.delete('page');
    urlSearch.applyParams(params);
  };

  const handleClearCustomFilterButtonClick = () => {
    clearFilters();
  };

  const updateSearchQuery = (value) => {
    const params = urlSearch.getParams();

    if (value) {
      params.set(searchQueryParam, value);
    } else {
      params.delete(searchQueryParam);
    }

    params.delete('page');
    urlSearch.applyParams(params);
  };

  const handleClearSearchClick = () => {
    setSearchValue('');
    updateSearchQuery('');
  };

  const handleFilterButtonClick = () => {
    // TODO
  };

  const debouncedUpdateSearchQuery = useDebounce(updateSearchQuery, 600);

  const handleSearchChange = (value) => {
    setSearchValue(value);
    debouncedUpdateSearchQuery(value);
  };

  return (
    <ManageSearch
      customFilterProps={{
        filterText: customFilterText,
        isFilterSet: hasCustomFilter,
        onClearButtonClick: handleClearCustomFilterButtonClick,
        onFilterButtonClick: onCustomFilterButtonClick,
        onFilterTextClick: onCustomFilterTextClick,
      }}
      filterButtonRef={filterDrawerTriggerRef}
      filtersCount={filters.filter(({ key }) => Boolean(urlSearch.getValues(key).length)).length}
      hasCustomFilterButton={hasCustomFilterButton}
      hasFilterButton={Boolean(filters.length) && !hasCustomFilter}
      isCustomFilterDisabled={isCustomFilterButtonDisabled || isSelectingFilters}
      isDisabled={isDisabled}
      isFilterButtonDisabled={isSelectingFilters}
      onFilterButtonClick={handleFilterButtonClick}
      onSearchChange={handleSearchChange}
      onSearchClick={handleClearSearchClick}
      searchValue={searchValue}
    />
  );
};

ManageSearchContainer.propTypes = {
  customFilterText: PropTypes.string,
  filters: PropTypes.arrayOf(PropTypes.shape({ key: PropTypes.string })),
  hasCustomFilterButton: PropTypes.bool,
  isCustomFilterButtonDisabled: PropTypes.bool,
  isCustomFilterChatOpen: PropTypes.bool,
  isDisabled: PropTypes.bool,
  onCustomFilterButtonClick: PropTypes.func,
  onCustomFilterTextClick: PropTypes.func,
  searchQueryParam: PropTypes.string,
};

export default ManageSearchContainer;
